import type { Node as ProseNode } from '@milkdown/kit/prose/model';
import { Plugin, PluginKey } from '@milkdown/kit/prose/state';
import { $prose } from '@milkdown/kit/utils';

/**
 * Returns true as soon as one table node is found, stopping the traversal early.
 * Avoids a full O(n) walk when we only care whether any table exists.
 */
function hasTable(doc: ProseNode): boolean {
  let found = false;
  doc.descendants((node) => {
    if (found) {
      return false;
    }
    if (node.type.name === 'table') {
      found = true;
      return false;
    }
  });
  return found;
}

/**
 * Rejects transactions that would remove the last GFM table from the document.
 *
 * Uses `tr.doc` (the post-transaction document computed by ProseMirror) instead of
 * `state.apply(tr)` — calling state.apply on every keystroke was O(document) work and
 * caused the browser to freeze while editing the stakeholder table.
 */
export const crepeStakeholderTableLockPlugin = $prose(() => {
  return new Plugin({
    key: new PluginKey('bdp-crepe-stakeholder-table-lock'),
    filterTransaction(tr, state) {
      if (!tr.docChanged) {
        return true;
      }
      // Only check the post-transaction doc when the current doc has a table.
      if (!hasTable(state.doc)) {
        return true;
      }
      // tr.doc is the document after all steps — no need to call state.apply().
      return hasTable(tr.doc);
    },
  });
});
